import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@solar/app.config';
import { Site } from 'solar-bo';
import { getLocaleDateFormat } from '@angular/common';
import { Observable, of, BehaviorSubject, from } from 'rxjs';
import { delay, tap, catchError, mergeMap } from 'rxjs/operators';
import { shareReplay, share, switchMap, map } from 'rxjs/operators';
import * as uuid from 'uuid';


import { SdsService, ISdsAction } from '@solar/services/sds.service';
import { TimePerf } from 'shtools';
import { SolarDatabase } from './solardatabase';
import { CacheSitePanels } from 'solar-bo';;


@Injectable({
    providedIn: 'root'
})
export class SolarCacheService {
    public db = new SolarDatabase();
    //todo: we need to control the size of cached elements

    /**
     * site cache
     */
    public sites$: BehaviorSubject<Site[]> = new BehaviorSubject([]);
    /**
     * store site panels
     */
    private sitePanels$: BehaviorSubject<CacheSitePanels[]> = new BehaviorSubject([]);

    localdebug: boolean = false;

    constructor() {

    }

    configDB() {

    }

    /**
     * return sites array
     */
    get sites() {
        return this.sites$.value;
    }
    /**
     * return a site from cache
     */
    siteById(id: string) {
        //console.log("siteById", this._sites.getValue());
        let site = this.sites$.getValue().find(s => s.id == id);
        return site;
    }
    /**
     * delete a site from cache
     * @param id 
     */
    siteListDelete(id: string) {
        let index = this.sites$.getValue().findIndex(s => s.id == id, 0);
        if (index > -1) {
            this.sites$.getValue().splice(index, 1);
            //remove panels too
            this.sitePanelsDelete(id);
        }
    }
    /**
     * add or update a new site to cache
     * @param site 
     */
    siteListAddedorEdited(site: Site):Site {
        let index = this.sites$.getValue().findIndex(s => s.id == site.id);
        if (index > -1) {
            //try to update
            let siteActual=this.sites$.getValue()[index];            
            siteActual.info["modules"]=20;
            console.log("siteactual:",siteActual);
            Object.assign(siteActual,site);
            console.log("siteactual assign:",siteActual);
            return siteActual;
        } else {
            this.sites$.value.push(site);
            return site;
        }
    }
    /**
     * Return panels of site
     * @param id 
     */
    sitePanelsById(id: string): any[] {
        const item = this.sitePanels$.getValue().find(s => s.id == id);
        if (item) {
            return item.panels;
        }
        return null;
    }
    /**
     * return a site panels from cache
     */
    async sitePanelsByIdAsync(id: string) {
        try {
            const panels = this.sitePanelsById(id);
            if (panels) {

                return Promise.resolve(panels);
            }
            else {
                //check cache
                const c = await this.getSitePanelsFromDB(id);
                return c;
            }
        } catch (error) {
            console.log(error);
            return null;//evitamos bloquear la aplicacion. el usuario no necesita saber el problema.
        }
    }

    private async getSitePanelsFromDB(id: string): Promise<any[]> {
        try {

            let f = await this.db.sitepanels.get(id);
            if (f) {
                this.addSitePanelsToList(id, f);
                console.log("----getSitePanelsFromDB from cache", f);
                return f.panels;
            } else {
                return null;
            }


        } catch (error) {
            console.log(error);
        }
    }
    handleError(error) {
        console.log(error);
    }

    private addSitePanelsToList(id: string, obj: CacheSitePanels) {
        let item = this.sitePanels$.getValue().find(s => s.id == id);
        if (item) {
            //borrar actual o asignar
            item.panels = obj.panels;
        }
        else {
            this.sitePanels$.value.push(obj);
        }

    }

    private delay(ms: number): Promise<void> {
        return new Promise<void>(resolve =>
            setTimeout(resolve, ms));
    }

    /**
     * add or update a new site to cache
     * @param sitePanels 
     */
    sitePanelsAddedorEdited(id: string, sitePanels: any[]) {
        let sp: CacheSitePanels = { id: id, panels: sitePanels };
        this.addSitePanelsToList(id, sp);
        this.db.sitepanels.put(sp, id);
    }
    /**
     * delete a site from cache
     * @param id 
     */
    sitePanelsDelete(id: string) {
        let index = this.sitePanels$.getValue().findIndex(s => s.id == id, 0);
        if (index > -1) {
            this.sitePanels$.getValue().splice(index, 1);
        }
        this.db.sitepanels.delete(id);
    }

}